import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import App from "App";
import { createRoot } from "react-dom/client";
import "./global";
import "./polyfills";

// Disable console logs in production
if (process.env.NODE_ENV === "production") {
	console.log = () => {};
	console.debug = () => {};
	console.info = () => {};
	// Keep console.warn and console.error for debugging critical issues
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
serviceWorker.unregister();
